import { render } from "./AddNewInfo.vue?vue&type=template&id=58006ade&scoped=true"
import script from "./AddNewInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewInfo.vue?vue&type=script&setup=true&lang=js"

import "./AddNewInfo.vue?vue&type=style&index=0&id=58006ade&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58006ade"],['__file',"src/containers/logs/logCollections/components/LogMetricInfo/AddNewInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58006ade"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58006ade', __exports__)) {
    api.reload('58006ade', __exports__)
  }
  
  module.hot.accept("./AddNewInfo.vue?vue&type=template&id=58006ade&scoped=true", () => {
    api.rerender('58006ade', render)
  })

}


export default __exports__